import { postIssueLottery } from '../api/postIssueLottery';

const setPostIssueLottery = (params, setOpenModal) => {
    return async (dispatch, getState) => {
        try {
            await postIssueLottery(params);
            setOpenModal(true)
           
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostIssueLottery
}